export function getSubdomain() {
  const host = window.location.hostname;
  const baseVar = window.location.protocol + "//" + host + "/api/v2/";
  return baseVar;
}

export function getApiBase() {
  return window.location.protocol + '//' + window.location.hostname + '/api/v2/';
}

export function getBaseDomain() {
  const host = window.location.hostname;
  return host.substring(host.indexOf('.') + 1);
}

export function getImageBase() {
  return window.location.protocol + '//' + window.location.hostname + '/';
}

/**
 * #1694 — the host whose Android App Link can foreground the native app.
 *
 * App Link handoff only happens on a host the device has VERIFIED for
 * com.callsteward.mobile. Exactly three are verified (`pm get-app-links`):
 *
 *     stage-callsteward.com · admin.callsteward.com · admin.callsteward.ca
 *
 * The desktop web app does NOT run on any of them — it runs on `login.` and on
 * tenant subdomains — so `window.location.origin` is never the right target:
 * `https://login.stage-callsteward.com/open/mobile` resolves to Chrome and stays
 * in the browser. App Links do not require same-origin, so we deliberately send
 * the user cross-origin to the verified host for THIS environment.
 *
 * Matching is on the environment's own domain, so a stage session can only ever
 * resolve to the stage host — a stage page must never bounce to production (the
 * old `cs3.me/confirm2` path did exactly that: stage → login.callsteward.com).
 *
 * Returns null when the host is unrecognised (a preview box, an IP, localhost),
 * so callers can fall back to in-browser behaviour rather than navigate to a
 * host that would 404 or cross environments.
 */
export function getAppLinkHost(hostname) {
  const host = (hostname || window.location.hostname || '').toLowerCase();

  // Ordered: the stage domain is checked first so it can never fall through to
  // a production match.
  const VERIFIED = [
    { domain: 'stage-callsteward.com', appLinkHost: 'stage-callsteward.com' },
    { domain: 'callsteward.ca', appLinkHost: 'admin.callsteward.ca' },
    { domain: 'callsteward.com', appLinkHost: 'admin.callsteward.com' },
  ];

  for (let i = 0; i < VERIFIED.length; i++) {
    const entry = VERIFIED[i];
    if (host === entry.domain || host.endsWith('.' + entry.domain)) {
      return entry.appLinkHost;
    }
  }

  return null;
}

/** #1694 — the full deep link that foregrounds the app, or null if unavailable. */
export function getReturnToAppUrl(hostname) {
  const appLinkHost = getAppLinkHost(hostname);
  return appLinkHost ? 'https://' + appLinkHost + '/open/mobile' : null;
}

// #1478 — apply headers to a raw XMLHttpRequest, skipping any value that is
// null/undefined or the literal strings "undefined"/"null". Mirrors the axios
// api.js request-interceptor sanitizer for the Drive preview/download/upload
// paths that use raw XHR (which bypass the axios interceptor entirely). Without
// this, setRequestHeader('cs3-context-role', undefined) coerces to the literal
// "undefined" and trips ValidateRoleHeader once #1432 flips to enforce.
export function safeSetXhrHeaders(xhr, headers) {
  Object.keys(headers || {}).forEach(function (key) {
    var v = headers[key];
    if (v === undefined || v === null || v === 'undefined' || v === 'null') return;
    xhr.setRequestHeader(key, v);
  });
}

export const global = [
    {
        'BASE_URL': getSubdomain(),
        'IMAGE_URL': getImageBase(),
        'CLIENT_BASE': getBaseDomain() + '/',
        'REPORT_URL': "https://reports.callsteward.com/"
    },
];
